import React from "react";
import {PaymentType, PaymentTypeToName, ServiceIdToName} from "../consts.js";
import {openWindow} from "../http/WindowOpener.jsx";
import {validateOrderDisabledForEdit} from "../admin/AdminOrders/utils.jsx";
import {EDIT_ORDER_ERRORS} from "../admin/AdminOrders/consts.jsx";
import {createProductLink} from "../marketplace/MarketplaceHelper.jsx";
import {OrderStatus} from "../components/OrderStatusLabel.jsx";
import viewIcon from "../images/icons/view.svg";
import editIcon from "../images/icons/edit.svg";
import duplicateIcon from "../images/icons/duplicate.svg";
import ratingIcon from "../images/icons/rating.svg";

export const BUDGET_LOAD_TRANSACTION = "budgetLoad";
export const ON_ORDER_BUDGET_TRANSACTION = "onOrderBudgetTransaction";

export const TransactionServiceIdToName = {
    ...ServiceIdToName,
    [BUDGET_LOAD_TRANSACTION]: "טעינת תקציב"
};

export const AdminOrdersPaymentTypeToName = {
    ...PaymentTypeToName,
    [BUDGET_LOAD_TRANSACTION]: "טעינת תקציב",
    [PaymentType.Budget]: "מימושי תקציב (שולם מראש)",
    [ON_ORDER_BUDGET_TRANSACTION]: "מימושי תקציב (מסגרת)"
};

export const getOrderPaymentType = order => {
    if (order.paymentType === PaymentType.Budget && order.payOnOrderBudgetTransaction) {
        return AdminOrdersPaymentTypeToName[ON_ORDER_BUDGET_TRANSACTION];
    }

    return AdminOrdersPaymentTypeToName[order.paymentType];
};

export const excelSheetsTitle = {
    needInvoiceTransactions: "חשבונית להפקה",
    budgetsOrder: "עסקאות תקציב - לא לגביה",
    creditCardOrders: "עסקאות אשראי - לא לגביה",
    orders: "הזמנות"
};

export const generateCompanyOrdersActions = (me = {}, services = []) => [
    {
        title: "צפייה בהזמנה",
        icon: <img src={viewIcon} alt="" />,
        onClick: order => openWindow(`/events/${order.eventId}/orderV2`)
    },
    {
        title: "צפייה בסטטוס השילוח",
        onClick: order => `/events/${order.eventId}/orderDeliveryStatus`
    },
    {
        title: "עריכת הזמנה",
        icon: <img src={editIcon} alt="" />,
        disabled: order => !!validateOrderDisabledForEdit(order, false) || !me?.features?.edit_order,
        onClick: order => `/events/${order.eventId}/orderDeliveryStatus`,
        tooltip: order =>
            !!validateOrderDisabledForEdit(order, false) || !me?.features?.edit_order ? EDIT_ORDER_ERRORS : null
    },
    {
        title: "שכפל הזמנה",
        icon: <img src={duplicateIcon} alt="" />,
        disabled: order => !!order.isVoucherOrder,
        onClick: order => {
            const product = {
                provider: {
                    providerId: order.providerId
                },
                service: {
                    productId: order.productId
                }
            };
            const productLinkUrl = createProductLink(product, {
                me,
                services,
                serviceId: order.serviceId
            });

            const params = new URLSearchParams();
            params.append("fromEventId", order.eventId);

            openWindow(`${productLinkUrl}/booking?${params.toString()}`);
        }
    },
    {
        title: "דירוג הזמנה",
        icon: <img src={ratingIcon} alt="" />,
        onClick: order => openWindow(`/order/${order.eventId}/feedback`),
        disabled: order => !!order?.rating,
        shouldHide: order => !order?.eventStatusMap?.some(({id}) => id === OrderStatus.delivered)
    }
];
